/** Alfabeto sin caracteres ambiguos (O/0, I/1) — patrón podcast/cloud-sync. */
const JOIN_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export const JOIN_CODE_LENGTH = 6;

export function generateJoinCode(length = JOIN_CODE_LENGTH): string {
  return Array.from({ length }, () =>
    JOIN_CODE_ALPHABET[Math.floor(Math.random() * JOIN_CODE_ALPHABET.length)],
  ).join('');
}

export function normalizeJoinCode(raw: string): string {
  return raw.trim().toUpperCase().replace(/[^A-Z2-9]/g, '').slice(0, JOIN_CODE_LENGTH);
}

export function isValidJoinCode(code: string): boolean {
  const normalized = normalizeJoinCode(code);
  return (
    normalized.length === JOIN_CODE_LENGTH &&
    [...normalized].every((ch) => JOIN_CODE_ALPHABET.includes(ch))
  );
}

export function generateRoomId(): string {
  return `room_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

export function generateParticipantId(): string {
  return `ptc_${Math.random().toString(36).slice(2, 10)}`;
}

export function generateTeamId(index: number): string {
  return `team_${index + 1}`;
}

/** Colores predefinidos para equipos aleatorios. */
export const TEAM_COLORS = [
  '#3B82F6',
  '#EF4444',
  '#10B981',
  '#F59E0B',
  '#8B5CF6',
  '#EC4899',
  '#06B6D4',
  '#84CC16',
] as const;
